import type { PostLanguage } from "@/types/post";

export const DEFAULT_POST_LANGUAGE: PostLanguage = "it";
export const PUBLIC_LANGUAGE_HEADER = "x-sp-public-lang";
export const SUPPORTED_POST_LANGUAGES: readonly PostLanguage[] = ["it", "en"];

export function parsePostLanguage(value: string | null | undefined): PostLanguage | null {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === "it" || normalized === "en") {
    return normalized;
  }

  return null;
}

export function parsePostLanguageOrDefault(
  value: string | null | undefined,
): PostLanguage {
  return parsePostLanguage(value) ?? DEFAULT_POST_LANGUAGE;
}
